import React from 'react';
import './modal.css';
import Button from 'components/Button/Button';
import Divider from 'components/Divider/Divider';
import { IFooterButtonModal } from 'types/Modal';

interface ModalProps {
  isOpen: boolean;
  showHeader?: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  showCloseButton?: boolean;
  footerButtons?: IFooterButtonModal[];
  className?: string;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  title,
  showHeader = true,
  showCloseButton = true,
  footerButtons = [],
  className = '',
}) => {
  if (!isOpen) return null;

  return (
    <div className='modal-overlay'>
      <div
        className={`modal${className ? ` ${className}` : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        {showHeader && (
          <div className='modal-header'>
            <h2>{title}</h2>
            {showCloseButton && (
              <button className='modal-close-button' onClick={onClose}>
                &times;
              </button>
            )}
          </div>
        )}

        <div className='modal-content'>{children}</div>
        {footerButtons.length > 0 && (
          <>
            <Divider />
            <div className='modal-footer'>
              {footerButtons.map((button, index) => (
                <Button
                  key={index}
                  type='submit'
                  label={button.text}
                  color={button.color}
                  onClick={button.onClick}
                  disabled={button.disabled}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Modal;
